import Answers from '@crehana/icons/Answers';
import Chronometer from '@crehana/icons/Chronometer';
import Sofa from '@crehana/icons/Sofa';
import SquareQuestion from '@crehana/icons/SquareQuestion';
import { secondaryMain } from '@crehana/ui/dist/styles/colors';

export const ORGANIZATIONS = 'PARA EMPRESAS';
export const TITLE = ['Bienvenido al ', 'IQ', 'Digital ', 'Test de Crehana'];
export const SUBTITLE =
  'Tómate unos minutos y pon a prueba tus conocimientos sobre el mundo digital';
export const CONSIDERATIONS_LIST = [
  {
    icon: SquareQuestion,
    color: secondaryMain,
    size: 40,
    title: 'Son 20 preguntas',
    subtitle: 'Se evaluarán 4 aspectos:',
  },
  {
    icon: Chronometer,
    color: secondaryMain,
    size: 34,
    title: 'Preguntas con tiempo',
    subtitle: 'Tienes 30 segundos para responder cada una.',
  },
  {
    icon: Answers,
    color: secondaryMain,
    size: 40,
    title: 'Respuestas',
    subtitle: 'Tienes 30 segundos, una vez enviadas, no podrás cambiarlas.',
  },
  {
    icon: Sofa,
    color: secondaryMain,
    size: 40,
    title: 'Espacio de concentración',
    subtitle: 'Busca un lugar tranquilo para resolver el test.',
  },
];
export const START = '¡Empecemos!';
export const PERCENTAGE = 'Total test:';
export const COMPLETED = 'completado';
export const TIME_REMAINING = 'TIEMPO RESTANTE';
export const NEXT_QUESTION = 'Siguiente pregunta';
export const FINISH = 'Finalizar';
export const LOADING_IQ = 'Definiendo tu IQ Mindset';
export const METRICS_TITLE = 'Detalle general de tu evaluación';
export const ADVANCE = 'Avanzado';
export const INTERMEDIATE = 'Intermedio';
export const BEGINNER = 'Principiante';
export const LEVEL = 'NIVEL:';
export const DIGITAL_IQ = 'TU IQ DIGITAL';
export const POINTS = 'PUNTOS';
export const SKILLS_OPORTUNITIES =
  'HABILIDADES DONDE TIENES OPORTUNIDAD DE MEJORAR SON:';
export const LEVEL_REACHED = 'CONSEGUÍ EL NIVEL';
export const SKILL_ANALYSIS = 'Análisis de tus habilidades';
export const SKILL_ANSWERS = 'respuesta correcta de';
export const SKILL_ANSWERS_PLURAL = 'respuestas correctas de';
export const HARD_SKILLS_INFO =
  'Hard Skills incluye: Mkt digital, analitycs, UX/UI, Agile/Scrum';
export const LINK_DISABLED = 'El enlace ya no está disponible.';
export const COMUNICATE_HR =
  'Si crees que es un error comunícate con tu área de HR.';
export const TITLE_RECOMMENDED = 'Elevemos tus habilidades de';
export const ERROR_TO_LOAD_COURSES = 'Ocurrió un error al obtener los cursos.';
export const ERROR = 'Ocurrió un error, intenta recargando la página';
export const ERROR_TO_SEND_RESPONSE =
  'Ocurrió un error al enviar tu respuesta, inténtalo de nuevo';
export const BEGINNER_TEXT =
  'Te encuentras rodeado de un ecosistema digital y herramientas de productividad que te pueden ayudar a ser más productivo pero no las aprovechas al máximo. Por eso es que hemos diseñado un track que te dará las bases necesarias para mejorar.';
export const BEGINNER_RANGE = '0 - 33';
export const INTERMEDIATE_TEXT =
  'Conoces bien tu entorno digital y posees gran conocimiento cuando se trata de utilizar herramientas o metodologías digitales. Por eso hemos diseñado un track que te brindará herramientas y técnicas adicionales para que subas al siguiente nivel.';
export const INTERMEDIATE_RANGE = '33 - 66';
export const ADVANCE_TEXT =
  'Para ti es natural estar rodeado de un entorno de innovación y herramientas digitales, te encanta estar en constante aprendizaje y estás al tanto de todas las novedades y tendencias de productividad. Hemos diseñado un track que te permitirá mantener tu nivel y a la par descubrir técnicas qué mantendrán tu nivel.';
export const ADVANCE_RANGE = '66 - 100';
export const FINISH_SKILL_IQ = 'Terminaste tu evaluación';
export const SHARE_FACEBOOK = 'Comparte por Facebook';
export const SHARE_LINKEDIN = 'Comparte por LinkedIn';
export const LEGEND_CHART = 'Colaboradores de tu organización';
